import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [视频聊天结束页详情] http://wiki.xunlei.cn/pages/viewpage.action?pageId=156933549
export const homepage = createAsyncThunk(
  'Saada/live/hiya_socialize/say_hi_config',
  async (arg, store: any) => {
    const resp = await http.post('/live/hiya_socialize/say_hi_config', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export interface InitialStateType {
  list?: {
    reply_rule: string //	左边的文案
    income_str: string //	右边的文案
    show_pearl: boolean //	是否显示珍珠图标
  }[]
}

const initialState: InitialStateType = {}

export const ChatIncomeSlice = createSlice({
  name: 'Animal_Bee',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, {list: action.payload?.list || []})
    })
  },
})
export default ChatIncomeSlice.reducer
export const ChatIncomeActions = ChatIncomeSlice.actions

export const useChatIncomeState = () => {
  const data = useSelector((state) => {
    return state.Animal_Bee
  })
  return data
}
